import axios from 'axios'

/*
 * The build/version footer.
 *
 * Was an Angular factory taking `$http` (step 35 of #614). It uses axios now; this call has no
 * token, and the endpoint is public.
 */
const footerService = {
  version: function () {
    return axios.get('/version')
  },
}

export default footerService
